import DataVBorderBox from './box';
export default DataVBorderBox;
